import { render, staticRenderFns } from "./returncarModal2.vue?vue&type=template&id=026bdbbe&scoped=true&"
import script from "./returncarModal2.vue?vue&type=script&lang=js&"
export * from "./returncarModal2.vue?vue&type=script&lang=js&"
import style0 from "./returncarModal2.vue?vue&type=style&index=0&id=026bdbbe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026bdbbe",
  null
  
)

export default component.exports